import { SINGLETON_ITEM } from "@p0security/shared/install/constants";
import { installedItems } from "@p0security/shared/install/installed";
import { Instructions } from "@p0security/shared/install/types";
import { AzureComponents } from "@p0security/shared/integrations/resources/azure/components";
import { toScope } from "@p0security/shared/integrations/resources/azure/helper";
import { AzureIntegration } from "@p0security/shared/integrations/resources/azure/types";
import { Typography } from "antd";
import { FrontendInstallContext, FrontendInstaller } from "install/types";
import { ReactNode } from "react";

import { appRegistrationPreqMessages } from "./util";

const azureIamAssessmentInstructionsFor = (
  context: FrontendInstallContext<AzureIntegration>,
  id: string
): Instructions<ReactNode> => {
  const azureApp = installedItems("azure-app", context.config);
  const { clientId, clientServicePrincipalId } = azureApp[SINGLETON_ITEM] ?? {};
  if (!clientId || !clientServicePrincipalId) {
    throw new Error("Azure App Registration is not installed.");
  }
  const shell = [
    {
      header:
        "Create role assignment of service principal to Reader Role in the current subscription",
      command: `az role assignment create --assignee ${clientId} --role "Reader" --scope ${toScope(id)}`,
    },
  ];

  return {
    help: (
      <Typography.Paragraph>
        In order to provision access to your Azure subscription, we need to
        assign Reader access to the Azure App Registration you&apos;ve already
        integrated with P0.
      </Typography.Paragraph>
    ),
    commands: {
      shell,
    },
  };
};

export const azureIamAssessmentInstaller: FrontendInstaller<
  typeof AzureComponents
>["iam-assessment"] = {
  prerequisiteMessages: appRegistrationPreqMessages,
  instructions: azureIamAssessmentInstructionsFor,
  items: {},
};
